module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_03_bg-6e5bc67651f21b15d5ff7da7f171a3cb.png";